export const sampleLaptopDeals = [
  {
    title: 'ASUS VivoBook F510UA',
    link: 'https://www.amazon.com/gp/product/B0762S8PYM/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0762S8PYM&linkCode=as2&tag=permutize-20&linkId=470e763d20dd1dab1064861923e0a479',
    pictureLink: 'https://images-na.ssl-images-amazon.com/images/I/41ep9XKCNHL._AC_US436_QL65_.jpg',
    manufacturer: 'Asus',
    model: 'F510UA-AH51',
    screen: {
      size: 15.6,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 3.7,
    dimensions: {
      length: 14.2,
      width: 9.6,
      height: 0.8
    },
    cpu: {
      title: 'Intel Core i5 8th Gen i5-8250U',
      cores: 4,
      clockSpeed: 1.6,
      manufacturer: 'Intel',
      model: 'Core i5-8250U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'HDD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 5400
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'UHD 620',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen1',
        count: 1
      },
      {
        type: 'USB',
        version: '3.0',
        count: 1
      },
      {
        type: 'USB',
        version: '2.0',
        count: 2
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: false,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'Amazon',
    storeDisplayName: 'Amazon',
    price: 509.99
  },
  {
    title: 'Samsung 11.6" XE501C13-K01US Chromebook',
    link: 'https://www.bestbuy.com/site/samsung-11-6-chromebook-intel-celeron-2gb-memory-16gb-emmc-flash-memory-night-charcoal/6239913.p',
    pictureLink: 'https://pisces.bbystatic.com/image2/BestBuy_US/images/products/6239/6239913_sa.jpg',
    manufacturer: 'Samsung',
    model: 'XE501C13-K01US',
    screen: {
      size: 11.6,
      panelType: '',
      resolution: {
        width: 1366,
        height: 768
      },
      touchscreen: false
    },
    weight: 2.5,
    dimensions: {
      length: 11.4,
      width: 8.1,
      height: 0.7
    },
    cpu: {
      title: 'Intel Celeron N3060',
      cores: 2,
      clockSpeed: 1.6,
      manufacturer: 'Intel',
      model: 'Celeron N3060'
    },
    ram: {
      size: 2,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 16,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'HD 4000',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'ChromeOS',
        version: 0,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.0',
        count: 1
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'MicroSD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: false,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'BestBuy',
    storeDisplayName: 'Best Buy',
    price: 129
  },
  {
    title: 'Samsung 11.6" XE501C13-K02US Chromebook',
    link: 'https://www.bestbuy.com/site/samsung-11-6-chromebook-intel-celeron-4gb-memory-32gb-emmc-flash-memory-night-charcoal/6239912.p',
    pictureLink: 'https://pisces.bbystatic.com/image2/BestBuy_US/images/products/6239/6239913_sa.jpg',
    manufacturer: 'Samsung',
    model: 'XE501C13-K02US',
    screen: {
      size: 11.6,
      panelType: '',
      resolution: {
        width: 1366,
        height: 768
      },
      touchscreen: false
    },
    weight: 2.5,
    dimensions: {
      length: 11.4,
      width: 8.1,
      height: 0.7
    },
    cpu: {
      title: 'Intel Celeron N3060',
      cores: 2,
      clockSpeed: 1.6,
      manufacturer: 'Intel',
      model: 'Celeron N3060'
    },
    ram: {
      size: 4,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 32,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'HD 4000',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'ChromeOS',
        version: 0,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.0',
        count: 1
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'MicroSD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: false,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'BestBuy',
    storeDisplayName: 'Best Buy',
    price: 159
  },
  {
    title: 'ASUS VivoBook S410UN-NS74',
    link: 'https://www.amazon.com/gp/product/B07B7VFTN9/ref=as_li_qf_asin_il_tl?ie=UTF8&tag=permutize-20&creative=9325&linkCode=as2&creativeASIN=B07B7VFTN9&linkId=cc8f804bfb34f3232881c73138282722',
    pictureLink: 'https://images-na.ssl-images-amazon.com/images/I/41ARzdDxdFL._AC_US436_QL65_.jpg',
    manufacturer: 'Asus',
    model: 'S410UN-NS74',
    screen: {
      size: 14,
      panelType: '',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 3.2,
    dimensions: {
      length: 12.8,
      width: 8.9,
      height: 0.7
    },
    cpu: {
      title: 'Intel Core i7-8550U',
      cores: 4,
      clockSpeed: 1.8,
      manufacturer: 'Intel',
      model: 'Core i7-8550U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'Nvidia',
      model: 'MX 150',
      vram: 2
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen1',
        count: 1
      },
      {
        type: 'USB',
        version: '3.0',
        count: 2
      },
      {
        type: 'USB',
        version: '2.0',
        count: 2
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.2
    },
    // temporary:
    store: 'Amazon',
    storeDisplayName: 'Amazon',
    price: 799.99
  },
  {
    title: 'Acer Spin 3 2-in-1 SP314-51-59NM',
    link: 'https://www.staples.com/product_24328321',
    pictureLink: 'https://www.staples-3p.com/s7/is/image/Staples/s1129547_sc7?wid=512&hei=512',
    manufacturer: 'Acer',
    model: 'SP314-51-59NM',
    screen: {
      size: 14,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: true
    },
    weight: 3.75,
    dimensions: {
      length: 13.2,
      width: 9.,
      height: 0.8
    },
    cpu: {
      title: 'Intel Core i5 8th Gen i5-8250U',
      cores: 4,
      clockSpeed: 1.6,
      manufacturer: 'Intel',
      model: 'Core i5-8250U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 5400
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'UHD 620',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.0',
        count: 2
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [

    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: false,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'Staples',
    storeDisplayName: 'Staples',
    price: 499.99
  },
  {
    title: 'Apple 13.3" MacBook Pro Mid 2017',
    link: 'https://www.bhphotovideo.com/c/product/1342546-REG',
    pictureLink: 'https://static.bhphoto.com/images/images500x500/apple_mpxv2ll_a_13_3_macbook_pro_with_1496790426000_1342546.jpg',
    manufacturer: 'Apple',
    model: 'MPXV2LL/A',
    screen: {
      size: 13.3,
      panelType: 'IPS',
      resolution: {
        width: 2560,
        height: 1600
      },
      touchscreen: false
    },
    weight: 4,
    dimensions: {
      length: 13.8,
      width: 9.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i5 7th Gen i5-7267U',
      cores: 6,
      clockSpeed: 2.2,
      manufacturer: 'Intel',
      model: 'Core i5-7267U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'Iris Plus 650',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 4
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.2
    },
    // temporary:
    store: 'BH',
    storeDisplayName: 'B&H',
    price: 1399
  },
  {
    title: 'Apple 13.3" MacBook Air Silver Mid 2017',
    link: 'https://www.bhphotovideo.com/c/product/1343177-REG',
    pictureLink: 'https://static.bhphoto.com/images/images500x500/apple_z0uv_mq423_bh_macbook_air_i7_8gb_1497021373000_1343177.jpg',
    manufacturer: 'Apple',
    model: 'Z0UV-MQ423-BH',
    screen: {
      size: 13.3,
      panelType: 'TN',
      resolution: {
        width: 1440,
        height: 900
      },
      touchscreen: false
    },
    weight: 2.96,
    dimensions: {
      length: 12.8,
      width: 8.9,
      height: 0.7
    },
    cpu: {
      title: 'Intel Core i7 5th Gen i7-5650U',
      cores: 2,
      clockSpeed: 2.2,
      manufacturer: 'Intel',
      model: 'Core i7-5650U'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'HD Graphics 6000',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.1',
        count: 2
      },
      {
        type: 'MiniDisplayPort',
        version: 'Thunderbolt 2',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.0
    },
    // temporary:
    store: 'BH',
    storeDisplayName: 'B&H',
    price: 1399
  },
  {
    title: 'ASUS TUF Gaming FX504GE',
    link: 'https://www.bhphotovideo.com/c/product/1398212-REG',
    pictureLink: 'https://static.bhphoto.com/images/images500x500/1525187163000_1398212.jpg',
    manufacturer: 'Asus',
    model: 'FX504GE',
    screen: {
      size: 15.6,
      panelType: 'IPS',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 4.7,
    dimensions: {
      length: 25.2,
      width: 10.3,
      height: 1.0
    },
    cpu: {
      title: 'Intel Core i7 8th Gen i7-8750H',
      cores: 6,
      clockSpeed: 2.2,
      manufacturer: 'Intel',
      model: 'Core i7-8750H'
    },
    ram: {
      size: 8,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 128,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      },
      {
        type: 'HDD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 5400
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'Nvidia',
      model: 'GeForce GTX 1050 Ti',
      vram: 4
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB',
        version: '3.1',
        count: 2
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'Ethernet',
        version: '100/1000',
        count: 1
      },
      {
        type: 'HDMI',
        version: '1.4',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: true
    },
    bluetooth: {
      hasIt: true,
      version: 0
    },
    // temporary:
    store: 'BH',
    storeDisplayName: 'B&H',
    price: 899
  },
  {
    title: 'ASUSPRO B9440UA-XS74',
    link: 'https://www.newegg.com/Product/Product.aspx?Item=N82E16834234724',
    pictureLink: 'https://c1.neweggimages.com/NeweggImage/ProductImageCompressAll300/34-234-724-V21.jpg?ex=2',
    manufacturer: 'Asus',
    model: 'B9440UA-XS74',
    screen: {
      size: 14,
      panelType: '',
      resolution: {
        width: 1920,
        height: 1080
      },
      touchscreen: false
    },
    weight: 2.31,
    dimensions: {
      length: 12.6,
      width: 8.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i7 7th Gen i7-7500U',
      cores: 2,
      clockSpeed: 2.7,
      manufacturer: 'Intel',
      model: 'Core i7-7500U'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'HD 620',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Pro'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen 1',
        count: 2
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: 'SD Card Reader',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.1
    },
    // temporary:
    store: 'Newegg',
    storeDisplayName: 'Newegg',
    price: 859.99
  },
  {
    title: 'Apple 15.4" MacBook Pro Mid 2018',
    link: 'https://www.bhphotovideo.com/c/product/1423754-REG',
    pictureLink: 'https://static.bhphoto.com/images/images500x500/1531433244000_1423754.jpg',
    manufacturer: 'Apple',
    model: 'Z0V0-MR9321-BH',
    screen: {
      size: 15.4,
      panelType: 'IPS',
      resolution: {
        width: 2880,
        height: 1800
      },
      touchscreen: false
    },
    weight: 4,
    dimensions: {
      length: 13.8,
      width: 9.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i7 8th Gen i7-8750H',
      cores: 6,
      clockSpeed: 2.2,
      manufacturer: 'Intel',
      model: 'Core i7-8750H'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'AMD',
      model: '555X',
      vram: 4
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 4
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 5.0
    },
    // temporary:
    store: 'BH',
    storeDisplayName: 'B&H',
    price: 2449
  },
  {
    title: 'Apple 13.3" MacBook Pro Mid 2017',
    link: 'https://www.bhphotovideo.com/c/product/1343081-REG',
    pictureLink: 'https://static.bhphoto.com/images/images500x500/1497024944000_1343081.jpg',
    manufacturer: 'Apple',
    model: 'Z0UK-MPXT21-BH',
    screen: {
      size: 13.3,
      panelType: 'IPS',
      resolution: {
        width: 2560,
        height: 1600
      },
      touchscreen: false
    },
    weight: 3,
    dimensions: {
      length: 12.0,
      width: 8.4,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i5 7th Gen i5-7360U',
      cores: 2,
      clockSpeed: 2.3,
      manufacturer: 'Intel',
      model: 'Core i5-7360U'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'LPDDR3'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Integrated',
      manufacturer: 'Intel',
      model: 'Iris Pro 640',
      vram: 0
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 2
      },
      {
        type: 'DisplayPort',
        version: 'Thunderbolt 3',
        count: 2
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 4.2
    },
    // temporary:
    store: 'BH',
    storeDisplayName: 'B&H',
    price: 1549
  },
  {
    title: 'Apple 15.4" MacBook Pro Mid 2018',
    link: 'https://www.bhphotovideo.com/c/product/1423741-REG',
    pictureLink: 'https://www.bhphotovideo.com/images/images2500x2500/apple_mr942ll_a_15_4_macbook_pro_with_1423741.jpg',
    manufacturer: 'Apple',
    model: 'MR942LL/A',
    screen: {
      size: 15.4,
      panelType: 'IPS',
      resolution: {
        width: 2880,
        height: 1800
      },
      touchscreen: false
    },
    weight: 4,
    dimensions: {
      length: 13.8,
      width: 9.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i7 8th Gen i7-8850H',
      cores: 6,
      clockSpeed: 2.6,
      manufacturer: 'Intel',
      model: 'Core i7-8850H'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 512,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'AMD',
      model: '560X',
      vram: 4
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 4
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 5.0
    },
    // temporary:
    store: 'BH',
    storeDisplayName: 'B&H',
    price: 2649
  },
  {
    title: 'MSI GT63 Titan 4k',
    link: 'https://www.bhphotovideo.com/c/product/1411807-REG',
    pictureLink: 'https://static.bhphoto.com/images/images500x500/1528146373000_1411807.jpg',
    manufacturer: 'MSI',
    model: 'FX504GE',
    screen: {
      size: 15.6,
      panelType: 'IPS',
      resolution: {
        width: 3840,
        height: 2160
      },
      touchscreen: false
    },
    weight: 4.7,
    dimensions: {
      length: 25.2,
      width: 10.3,
      height: 1.0
    },
    cpu: {
      title: 'Intel Core i7 8th Gen i7-8850H',
      cores: 6,
      clockSpeed: 2.6,
      manufacturer: 'Intel',
      model: 'Core i7-8850H'
    },
    ram: {
      size: 16,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 256,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      },
      {
        type: 'HDD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 7200
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'Nvidia',
      model: 'GeForce GTX 1080',
      vram: 8
    },
    operatingSystems: [
      {
        type: 'Windows',
        version: 10,
        edition: 'Home'
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Gen2',
        count: 1
      },
      {
        type: 'USB',
        version: '3.1',
        count: 3
      },
      {
        type: 'USB',
        version: '2.0',
        count: 1
      },
      {
        type: 'Ethernet',
        version: '100/1000',
        count: 1
      },
      {
        type: 'DisplayPort',
        version: '1.2',
        count: 1
      },
      {
        type: 'HDMI',
        version: '',
        count: 1
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: true
    },
    bluetooth: {
      hasIt: true,
      version: 5.0
    },
    // temporary:
    store: 'BH',
    storeDisplayName: 'B&H',
    price: 2799
  },
  {
    title: 'Apple 15.4" MacBook Pro Mid 2018',
    link: 'https://www.bhphotovideo.com/c/product/1423790-REG',
    pictureLink: 'https://static.bhphoto.com/images/images500x500/apple_z0v0_mr9357_bh_macbook_pro_i9_2_9g_1531433244000_1423790.jpg',
    manufacturer: 'Apple',
    model: 'Z0V0-MR9357-BH',
    screen: {
      size: 15.4,
      panelType: 'IPS',
      resolution: {
        width: 2880,
        height: 1800
      },
      touchscreen: false
    },
    weight: 4,
    dimensions: {
      length: 13.8,
      width: 9.5,
      height: 0.6
    },
    cpu: {
      title: 'Intel Core i7 8th Gen i9-8950HK',
      cores: 6,
      clockSpeed: 2.6,
      manufacturer: 'Intel',
      model: 'Core i9-8950HK'
    },
    ram: {
      size: 32,
      manufacturer: '',
      model: '',
      sodimm: 'DDR4'
    },
    hardDisks: [
      {
        type: 'SSD',
        size: 1000,
        manufacturer: '',
        model: '',
        transferSpeed: -1,
        rpm: 0
      }
    ],
    gpu: {
      type: 'Discrete',
      manufacturer: 'AMD',
      model: '560X',
      vram: 4
    },
    operatingSystems: [
      {
        type: 'MacOS',
        version: 10.13,
        edition: ''
      }
    ],
    ports: [
      {
        type: 'USB-C',
        version: 'Thunderbolt 3',
        count: 4
      },
      {
        type: '3.5mm',
        version: 'microphone in/headphone out',
        count: 1
      },
      {
        type: 'Fingerprint Sensor',
        subtype: 'TouchID',
        version: '',
        count: 1
      }
    ],
    opticalDrives: [
    ],
    webcam: true,
    wifi: {
      hasIt: true,
      protocols: [
        'A',
        'B',
        'G',
        'N',
        'AC'
      ]
    },
    keyboard: {
      backLit: true,
      numericKeypad: false
    },
    bluetooth: {
      hasIt: true,
      version: 5.0
    },
    // temporary:
    store: 'BH',
    storeDisplayName: 'B&H',
    price: 3749
  }
];


// WEBPACK FOOTER //
// ./src/lib/laptop.js